var React = require('react');

function IconNoChange (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"icon - noChange","d":"m3 0 3 4H0z","style":{"fill":"#7E8FA8"}}));
}

IconNoChange.defaultProps = {"width":"6","height":"4","viewBox":"0 0 6 4"};

module.exports = IconNoChange;

IconNoChange.default = IconNoChange;
